import { useEffect } from 'react'
import styled from '@emotion/styled'
import { useRouter } from '../../utils/helper'
import { mobile, iphoneXLandscape } from '../../utils/responsive-helper'
import { setToken } from '../../utils/helper'
import { useGetToken, useExchangeLoginCode } from '../../services/user/user-query'
import Loading from '../../components/common/Loading'

const Layout = styled.div`
  display: flex;
  height: 100vh;

  ${mobile}, ${iphoneXLandscape} {
    flex-direction: column;
    > div {
      width: 100%;
    }
  }
`

const AuthCallback = (props: any) => {
  const { query } = useRouter<{ code?: string; samlAuth?: any }>()
  const { mutate: exchangeLoginCode } = useExchangeLoginCode()
  const { mutate: getToken } = useGetToken()

  useEffect(() => {
    const onGotToken = (token: any) => {
      setToken(token).then(() => {
        // replace เพื่อไม่ให้ code/samlAuth ค้างใน history แล้ววน callback ซ้ำ
        window.location.replace('/')
      })
    }

    if (query.code) {
      // แลก one-time code เป็น token
      exchangeLoginCode(query.code, { onSuccess: onGotToken })
    } else if (query.samlAuth === 'true') {
      // fallback สำหรับ API เวอร์ชันเก่าที่ส่ง token ผ่าน session
      getToken({}, { onSuccess: onGotToken })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query.code, query.samlAuth])

  return (
    <Layout>
      <Loading loading={true} >
        isLoading
      </Loading>
    </Layout>
  )
}

export default AuthCallback
